import type { ReactNode } from "react";
import { Typography } from "@circle-react-uikit/Typography";

interface WorkflowNameProps {
  children: ReactNode;
}

export const WorkflowName = ({ children }: WorkflowNameProps) => (
  <Typography.LabelSm weight="medium">
    <span className="break-normal">{children}</span>
  </Typography.LabelSm>
);
